"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-cycle
const types_1 = require("../../../store/types");
// eslint-disable-next-line import/no-cycle
const _1 = require(".");
const consts_1 = require("../consts");
// eslint-disable-next-line import/no-cycle
const Viewer_1 = __importDefault(require("../Viewer"));
const utils_1 = require("../utils");
const SlotCoverUtils_1 = require("./SlotCoverSnapping/SlotCoverUtils");
const notSnappingTypes = [
    types_1.COMPONENT_TYPE.END_CAP,
    types_1.COMPONENT_TYPE.PANEL_GASKET,
    types_1.COMPONENT_TYPE.TSLOT_COVER,
    types_1.COMPONENT_TYPE.FASTENER,
    types_1.COMPONENT_TYPE.FOOT,
    types_1.COMPONENT_TYPE.STEM_CASTER,
];
class ComponentObjectsBase extends _1.BaseObject3D {
    constructor() {
        super(...arguments);
        this.isCornerComponent = false;
    }
    getThickness() {
        return this.getLength();
    }
    checkAndFixSize() {
        if (!this.partDetails.isScalable) {
            return false;
        }
        return this.checkAndFixSizeByAxis(this.getScale(), 2, consts_1.consts.DEFAULT_MIN_LENGTH, this.partDetails.maxStockLength);
    }
    setCatalogProps(catalogItem) {
        var _a;
        super.setCatalogProps(catalogItem);
        const cornerCategory = (_a = catalogItem.categories) === null || _a === void 0 ? void 0 : _a.find((category) => category.name === 'Corners');
        this.isCornerComponent = !!cornerCategory;
        this.compatibleExtrusions = catalogItem.compatibleExtrusions;
    }
    copy(source, recursive = true) {
        super.copy(source, recursive);
        this.isCornerComponent = source.isCornerComponent;
        this.compatibleExtrusions = source.compatibleExtrusions;
        return this;
    }
    getCollisionExcludeIds() {
        const result = super.getCollisionExcludeIds();
        const connectionsToExtrusion = this.connectedItems.filter((item) => {
            return item.itemType === types_1.ITEM_TYPE.EXTRUSION;
        });
        if (connectionsToExtrusion.length > 0) {
            const viewer = Viewer_1.default.instance;
            connectionsToExtrusion.forEach((connection) => {
                result.push(connection.uuid);
                const object = viewer.getObjectById(connection.uuid);
                if (object) {
                    object.getTransformChildObjects().forEach((childObject) => result.push(childObject.uuid));
                }
            });
        }
        return result;
    }
    getConnectionExcludeIDs() {
        const result = super.getConnectionExcludeIDs();
        if (this.partDetails.componentType === types_1.COMPONENT_TYPE.FOOT ||
            this.partDetails.componentType === types_1.COMPONENT_TYPE.STEM_CASTER) {
            const viewer = Viewer_1.default.instance;
            const connectedComponents = this.connectedItems.filter((item) => item.itemType === types_1.ITEM_TYPE.COMPONENT);
            connectedComponents.forEach((connectedComponent) => {
                const componentObject = viewer.getObjectById(connectedComponent.uuid);
                if (componentObject) {
                    result.push(...utils_1.ConnectionUtils.getUUIDsOfExtrusionsConnectedToObject(componentObject));
                }
            });
        }
        else if (this.partDetails.componentType === types_1.COMPONENT_TYPE.PANEL_GASKET) {
            const viewer = Viewer_1.default.instance;
            const connectedExtrusions = this.connectedItems.filter((item) => item.itemType === types_1.ITEM_TYPE.EXTRUSION);
            connectedExtrusions.forEach((extrusionItem) => {
                const extrusion = viewer.getObjectById(extrusionItem.uuid);
                if (extrusion && extrusion instanceof _1.BaseObject3D) {
                    extrusion.connectedItems.forEach((connectedItem) => {
                        if (connectedItem.itemType === types_1.ITEM_TYPE.EXTRUSION) {
                            result.push(connectedItem.uuid);
                        }
                    });
                }
            });
        }
        return result;
    }
    get isSnappable() {
        return !notSnappingTypes.includes(this.partDetails.componentType);
    }
    getMasterSnappingPoints() {
        if (utils_1.Utils.isCoverComponent(this)) {
            return [
                (0, SlotCoverUtils_1.getSnappingPoint)(this)
                    .clone()
                    .add(this.directionNormal.clone().multiplyScalar(this.getLength() / 2)),
            ];
        }
        return super.getMasterSnappingPoints();
    }
}
exports.default = ComponentObjectsBase;
